<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row">
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Exp'}">
								<img class="img-fluid " width="80" src="static/images/item/icon_item_20003.png" alt="所需經驗值">
								<h2 class="mt-1 text-center">{{$t('UnitExp')}}</h2>
								<p class="s-word">{{ $t('unit_xp_caption') }}</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Mana'}">
								<img class="img-fluid " width="80" src="static/images/item/icon_item_94001.png" alt="裝備列表">
								<h2 class="mt-1 text-center">{{ $t('ManaCost') }}</h2>
								<p class="s-word">{{ $t('ManaCostCaption') }}</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Megami'}">
								<img class="img-fluid " width="80" src="static/images/item/icon_item_90005.png" :alt="$t('MegamiStone')">
								<h2 class="mt-1 text-center">{{ $t('MegamiStone') }}</h2>
								<p class="s-word">{{ $t('MegamiCostCaption') }}</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Stamina'}">
								<img class="img-fluid " width="80" src="static/images/item/icon_item_93001.png" alt="女神石">
								<h2 class="mt-1 text-center">{{ $t('CountStamina') }}</h2>
								<p class="s-word">主角體力經驗值表</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Clan'}">
								<img class="img-fluid " width="80" src="static/images/item/icon_item_90006.png" alt="戰隊幣">
								<h2 class="mt-1 text-center">{{ $t('ClanReward') }}</h2>
								<p class="s-word">戰隊排名獎勵</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Arena'}">
								<img class="img-fluid " src="static/images/item/icon_item_90003.png" alt="戰鬥競技場幣">
								<h2 class="mt-1 text-center">{{ $t('ArenaReward') }}</h2>
								<p class="s-word">戰鬥競技場排名獎勵</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'GrandArena'}">
								<img class="img-fluid " src="static/images/item/icon_item_90004.png" :alt="$t('PrincessArenaReward')">
								<h2 class="mt-1 text-center">{{$t('PrincessArenaReward')}}</h2>
								<p class="s-word">競技場排名獎勵</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'ArenaFindRank'}">
								<img class="img-fluid " src="static/images/item/icon_item_90003.png" alt="公主競技場">
								<h2 class="mt-1 text-center">{{ $t('ArenaFindYourRival') }}</h2>
								<p class="s-word">計算最高可找名次</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Dungeon'}">
								<img class="img-fluid " src="static/images/item/icon_item_90002.png" :alt="$t('DungeonReward')">
								<h2 class="mt-1 text-center">{{ $t('DungeonReward') }}</h2>
								<p class="s-word">地下城幣獎勵</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Stand'}">
								<img class="img-fluid " src="static/images/stand.png" alt="站位">
								<h2 class="mt-1 text-center">{{ $t('CharacterPosition') }}</h2>
								<p class="s-word">角色站位順序表</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'EquipmentRequire'}">
								<img class="img-fluid " src="/static/images/equipment/icon_equipment_103613.png" alt="Equipment Requirements">
								<h2 class="mt-1 text-center">{{ $t('EquipmentRequire') }}</h2>
								<p class="s-word">查詢裝備素材需求</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'UniqueEquipment'}">
								<img class="img-fluid " src="/static/images/equipment/icon_equipment_130581.png" alt="Unique Equipment Menu">
								<h2 class="mt-1 text-center">{{ $t('UniqueEquipmentMenu') }}</h2>
								<p class="s-word">查詢專用裝備資訊、花費</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'ExEquipment'}">
								<img class="img-fluid " src="/static/images/equipment/icon_equipment_4102201.png" alt="Unique Equipment Menu">
								<h2 class="mt-1 text-center">{{ $t('ExEquipmentMenu') }}</h2>
								<p class="s-word">查詢 EX 裝備資訊、花費</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'PieceOfMemory'}">
								<img class="img-fluid " src="/static/images/item/icon_item_31076.png" alt="角色碎片">
								<h2 class="mt-1 text-center">{{ $t('CharacterMemo') }}</h2>
								<p class="s-word">角色碎片取得一覽</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'UnitStatus'}">
								<img class="img-fluid " src="/static/images/unit_status.png" alt="角色數值">
								<h2 class="mt-1 text-center">{{ $t('UnitStatus') }}</h2>
								<p class="s-word">查詢角色資訊狀態等</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'StatusEffect'}">
								<img class="img-fluid " src="/static/images/skillEffect.png" alt="狀態圖示">
								<h2 class="mt-1 text-center">{{ $t('StatusImg') }}</h2>
								<p class="s-word">查詢狀態圖示</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'UnitXp'}">
								<img class="img-fluid " src="/static/images/xp.png" alt="經驗驗水">
								<h2 class="mt-1 text-center">{{ $t('UnitXpCalculate') }}</h2>
								<p class="s-word">計算角色經驗與瑪那</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'YukiXp'}">
								<img class="img-fluid " src="/static/images/unit_yuki.jpg" alt="主角經驗">
								<h2 class="mt-1 text-center">{{ $t('YukiXp') }}</h2>
								<p class="s-word">計算等級與天數</p>
							</router-link>
						</div>
					</div>
					<!-- <div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'UnitStartList'}">
								<img class="img-fluid " src="/static/images/unitStart.png" alt="角色出現順序">
								<h2 class="mt-1 text-center">{{ $t('CharacterOpenTime') }}</h2>
								<p class="s-word">臺日角色出現順序</p>
							</router-link>
						</div>
					</div> -->
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'EquipmentReduce'}">
								<img class="img-fluid anm-icon" src="/static/images/equipment/icon_equipment_101401.png" alt="狀態圖示">
								<h2 class="mt-1 text-center">{{ $t('EquipmentReduce') }}</h2>
								<p class="s-word">查詢設計圖需求減少數量</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Resume'}">
								<img class="img-fluid anm-icon" src="/static/images/resume.png" alt="履歷表">
										<h2 class="mt-1 text-center">{{ $t('Resume') }}</h2>
										<p class="s-word">建立履歷表</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'MapExtraDrop'}">
								<img class="img-fluid anm-icon" src="/static/images/equipment/icon_equipment_101101.png" alt="狀態圖示">
								<h2 class="mt-1 text-center">{{ $t('MapExtraDrop') }}</h2>
								<p class="s-word">查詢37張後的額外掉落</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Birthday'}">
								<img class="img-fluid anm-icon" src="/static/images/item/icon_item_50003.png" alt="角色生日表">
								<h2 class="mt-1 text-center">{{ $t('UnitBirthday') }}</h2>
								<p class="s-word">查詢角色的生日</p>
							</router-link>
						</div>
					</div>
					<div class="col-6 col-md-3 index-box py-4 text-center">
						<div class="index-item anm-icon-grow">
							<router-link :to="{ name: 'Whoami'}">
								<img class="img-fluid anm-icon" v-lazy="'/static/images/whoami.png'" alt="What's that" />
								<h2 class="mt-1 text-center">{{ $t('Whoami') }}</h2>
								<p class="s-word">{{$t('LittleGame')}}</p>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Other',
	metaInfo: {
		title: '其他資訊',
	},
	data() {
		return {}
	},
	computed: {},
	mounted: function() {}
}
</script>
<style scoped>
</style>